// File: components/LogoutConfirm.jsx
//
// The popup that asks "Are you sure you want to log out?" before
// actually signing the user out. Used on every page that has a
// Logout button (Home, Messages, Calendar, Resources).
//
// Props this component takes:
//   open       - true to show the popup, false to hide it
//   busy       - true while the sign-out is in flight (disables buttons)
//   onCancel   - what to do when the user clicks "Cancel"
//   onConfirm  - what to do when the user clicks "Log out"
//
// To change the wording, the colors, or the buttons, edit this one
// file — every page picks up the change automatically.

import React from "react";
import { COLORS, THEME } from "../theme";

export default function LogoutConfirm({ open, onCancel, onConfirm, busy = false }) {
  // If the popup isn't open, don't render anything at all.
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[160] flex items-center justify-center bg-black/55 px-5">
      <div
        className="w-full max-w-md rounded-3xl bg-white shadow-2xl  overflow-hidden"
        role="dialog"
        aria-modal="true"
        aria-labelledby="logout-confirm-title"
      >
        <div
          className="px-5 py-4 "
          style={{
            backgroundColor: COLORS.yellowBase,
          }}
        >
          <div
            id="logout-confirm-title"
            className="font-extrabold"
            style={{ color: THEME.text }}
          >
            Log out?
          </div>

          <div
            className="text-sm mt-1"
            style={{ color: "rgba(31,56,0,0.64)" }}
          >
            You will be returned to the sign-in screen.
          </div>
        </div>

        <div className="p-5 flex items-center justify-end gap-2">
          <button
            onClick={onCancel}
            disabled={busy}
            className="px-4 py-2 rounded-xl text-sm font-extrabold transition hover:opacity-90 disabled:opacity-60 border bg-white"
            style={{
              color: THEME.text,
              borderColor: THEME.border,
            }}
            type="button"
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            disabled={busy}
            className="px-4 py-2 rounded-xl text-sm font-extrabold text-white transition hover:opacity-90 disabled:opacity-60"
            style={{
              backgroundColor: COLORS.greenDark,
              boxShadow: "0 10px 20px rgba(64,115,0,0.18)",
            }}
            type="button"
          >
            {busy ? "Logging out..." : "Log out"}
          </button>
        </div>
      </div>
    </div>
  );
}
